import { useRef, useEffect } from "react";
import { Bold, Italic, List, ListOrdered, Heading2, Heading3, Link2, Undo, Redo } from "lucide-react";

const cmd = (command, value = null) => document.execCommand(command, false, value);

function ToolbarButton({ icon: Icon, onClick, title }) {
  return (
    <button
      type="button"
      title={title}
      onMouseDown={(e) => { e.preventDefault(); onClick(); }}
      className="flex h-8 w-8 items-center justify-center rounded-md text-slate-600 transition-colors hover:bg-ztk-blue/10 hover:text-ztk-blue dark:text-slate-300"
    >
      <Icon className="h-4 w-4" />
    </button>
  );
}

export default function RichTextEditor({ value = "", onChange, placeholder = "Wpisz treść...", testid }) {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (el && document.activeElement !== el && el.innerHTML !== (value || "")) {
      el.innerHTML = value || "";
    }
  }, [value]);

  const emit = () => onChange?.(ref.current.innerHTML);

  const addLink = () => {
    const url = window.prompt("Adres URL (https://...)");
    if (url) cmd("createLink", url);
    emit();
  };

  return (
    <div className="rounded-lg border border-input bg-background" data-testid={testid}>
      <div className="flex flex-wrap items-center gap-0.5 border-b border-border p-1.5">
        <ToolbarButton icon={Bold} title="Pogrubienie" onClick={() => { cmd("bold"); emit(); }} />
        <ToolbarButton icon={Italic} title="Kursywa" onClick={() => { cmd("italic"); emit(); }} />
        <div className="mx-1 h-5 w-px bg-border" />
        <ToolbarButton icon={Heading2} title="Nagłówek" onClick={() => { cmd("formatBlock", "<h2>"); emit(); }} />
        <ToolbarButton icon={Heading3} title="Podnagłówek" onClick={() => { cmd("formatBlock", "<h3>"); emit(); }} />
        <div className="mx-1 h-5 w-px bg-border" />
        <ToolbarButton icon={List} title="Lista punktowana" onClick={() => { cmd("insertUnorderedList"); emit(); }} />
        <ToolbarButton icon={ListOrdered} title="Lista numerowana" onClick={() => { cmd("insertOrderedList"); emit(); }} />
        <ToolbarButton icon={Link2} title="Wstaw link" onClick={addLink} />
        <div className="mx-1 h-5 w-px bg-border" />
        <ToolbarButton icon={Undo} title="Cofnij" onClick={() => { cmd("undo"); emit(); }} />
        <ToolbarButton icon={Redo} title="Ponów" onClick={() => { cmd("redo"); emit(); }} />
      </div>
      <div
        ref={ref}
        contentEditable
        suppressContentEditableWarning
        onInput={emit}
        onBlur={emit}
        data-placeholder={placeholder}
        className="ztk-prose min-h-[160px] px-3 py-2.5 text-sm leading-relaxed focus:outline-none empty:before:text-muted-foreground empty:before:content-[attr(data-placeholder)]"
      />
    </div>
  );
}
